export default __webpack_public_path__ + "images/LNH.12b855d.png";